import React, { FC } from "react";
import { Typography, TextField } from "@mui/material";
import { convertDecimalToFraction } from "../../../util/formulas/convertDecimalToFraction";
import NumberFormatCustom from "../../NumberFormatCustom";
import { RowLayout, ColLayout } from "../../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useWidthInputSelector from "./useWidthInputSelector";
import usePanelWidthInputSelector from "./usePanelWidthInputSelector";

const StyledForm = styled("form")(({ theme }) => ({
  "& > *": {
    margin: theme.spacing(1),
    width: "25ch",
  },
}));

interface SwingPanelInputProps {
  overall: number;
  panelWidth: string;
  handleChange: (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    option: string
  ) => void;
  inputTitle: string;
  option: string;
  isPivot?: boolean;
}

interface SwingWidthInputProps {
  overall: number;
  width: string;
  handleChange: (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    option: string
  ) => void;
  inputTitle: string;
  minWidth: number;
  maxWidth: number;
  option: string;
  equalPanels: boolean;
}

export const SwingWidthInput: FC<SwingWidthInputProps> = ({
  overall,
  width,
  handleChange,
  inputTitle,
  minWidth,
  maxWidth,
  option,
  equalPanels,
}) => {
  const { widthErr } = useWidthInputSelector(overall, minWidth, maxWidth);

  return (
    <StyledForm
      onSubmit={(e) => {
        e.preventDefault();
      }}
      noValidate
      autoComplete="off"
    >
      <RowLayout
        style={{
          width: "100%",
          justifyContent: "space-around",
          flexWrap: "wrap",
        }}
      >
        <Typography style={{ fontWeight: "bold", paddingRight: 20 }}>
          Net Frame Width{!equalPanels ? "(X)" : ""}:
        </Typography>

        <ColLayout>
          <TextField
            required
            style={{ backgroundColor: "white" }}
            variant="outlined"
            label={`Enter ${inputTitle}`}
            value={width}
            onChange={(event) => handleChange(event, option)}
            name="width"
            id="formatted-numberformat-input"
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
          />
          {widthErr ? (
            <Typography style={{ color: "red" }} variant="caption">
              {widthErr}
            </Typography>
          ) : (
            <Typography variant="caption">
              {convertDecimalToFraction(minWidth)}" to{" "}
              {convertDecimalToFraction(maxWidth)}"
            </Typography>
          )}
        </ColLayout>
      </RowLayout>
    </StyledForm>
  );
};

export const SwingPanelInput: FC<SwingPanelInputProps> = ({
  overall,
  panelWidth,
  handleChange,
  inputTitle,
  option,
  isPivot = false,
}) => {
  const { swingWidthErr, isAlum, isPico } = usePanelWidthInputSelector(
    isPivot,
    overall
  );

  return (
    <StyledForm
      onSubmit={(e) => {
        e.preventDefault();
      }}
      noValidate
      autoComplete="off"
    >
      <RowLayout
        style={{
          width: "100%",
          justifyContent: "space-around",
          flexWrap: "wrap",
        }}
      >
        <Typography style={{ fontWeight: "bold", paddingRight: 20 }}>
          Per Panel Width(Y):
        </Typography>
        <ColLayout>
          <TextField
            required
            style={{ backgroundColor: "white" }}
            variant="outlined"
            label={`Enter ${inputTitle}`}
            value={panelWidth}
            onChange={(event) => handleChange(event, option)}
            name="panelWidth"
            id="formatted-numberformat-input"
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
          />
          {swingWidthErr ? (
            <Typography style={{ color: "red" }} variant="caption">
              {swingWidthErr}
            </Typography>
          ) : isAlum || isPico ? (
            <Typography variant="caption">24" to 48"</Typography>
          ) : isPivot ? (
            <Typography variant="caption">28" to 96"</Typography>
          ) : (
            <Typography variant="caption">24" to 42"</Typography>
          )}
        </ColLayout>
      </RowLayout>
    </StyledForm>
  );
};
